import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonVariant, ButtonSize, Group, GroupGutter, GroupVerticalAlign } from '@as/cotopaxi';
import { RANGE_FILTER } from '@as-react/common-types';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { AppliedFilterItem } from './AppliedFilterItem';
export const AppliedFilterRow = ({ flattenedActiveFilters, onToggleFilter, onRemoveAllFilters, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    if (!(!!flattenedActiveFilters && flattenedActiveFilters.length > 0)) {
        return null;
    }
    const getKey = (activeFilterItem) => activeFilterItem.filterType === RANGE_FILTER
        ? activeFilterItem.filterOn
        : `${activeFilterItem.filterOn}_${activeFilterItem.filterKey}`;
    return (_jsxs(Group, { gutter: GroupGutter.SMALL, valign: GroupVerticalAlign.CENTER, children: [flattenedActiveFilters.map(activeFilterItem => (_jsx(AppliedFilterItem, { onToggleFilter: onToggleFilter, activeFilterItem: activeFilterItem }, getKey(activeFilterItem)))), "\u2003", _jsx(Button, { variant: ButtonVariant.LINK, onClick: onRemoveAllFilters, size: ButtonSize.SMALL, text: t('product.lister.filter.clear'), dataQA: "clear-all-applied-filters" })] }));
};
